import React, { ReactElement } from 'react';
import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import CircularProgress from '@mui/material/CircularProgress';
import Modal from '@mui/material/Modal';
import Typography from '@mui/material/Typography';

import styles from './pop-up.module.scss';

type Props = {
  isOpen: boolean;
  handleOnClose?: React.ReactEventHandler<object>;
  title: string;
  body: string | ReactElement;
  primaryButtonText?: string;
  secondaryButtonText?: string;
  primaryButtonAction?: React.ReactEventHandler<object>;
  secondaryButtonAction?: React.ReactEventHandler<object>;
  isLoadingPrimaryAction?: boolean;
  showLoadingIndicator?: boolean;
};

const PopUp = ({
  isOpen,
  handleOnClose,
  title,
  body,
  primaryButtonText,
  secondaryButtonText,
  primaryButtonAction,
  secondaryButtonAction,
  isLoadingPrimaryAction,
  showLoadingIndicator,
}: Readonly<Props>): React.JSX.Element => (
  <Modal open={isOpen} onClose={handleOnClose}>
    <Box className={styles.modalContainer}>
      <Typography className={styles.heading} variant="h3">
        {title}
      </Typography>
      <Typography className={styles.content} margin="16px 0px 24px 0px" variant="subtitle1">
        {body}
      </Typography>

      {showLoadingIndicator && (
        <div className={styles.progressIndicatorContainer}>
          <CircularProgress />
        </div>
      )}
      <div className={styles.buttons}>
        {secondaryButtonText && secondaryButtonAction && (
          <Button
            data-testid={`popup-button-${secondaryButtonText}`}
            className={styles.button}
            variant="text"
            onClick={secondaryButtonAction}
          >
            {secondaryButtonText}
          </Button>
        )}
        {primaryButtonText && primaryButtonAction && (
          <Button
            data-testid={`popup-primary-action-button-${primaryButtonText}`}
            className={styles.button}
            variant="contained"
            onClick={primaryButtonAction}
            disabled={isLoadingPrimaryAction}
          >
            {isLoadingPrimaryAction ? <CircularProgress size={24} /> : primaryButtonText}
          </Button>
        )}
      </div>
    </Box>
  </Modal>
);

export default PopUp;
